export default __webpack_public_path__ + "static/video1-73ff5776f02b081a35c469e92f91297b.webm";